<!-- eslint-disable prettier/prettier -->
<template>
  <section class="quotewizard">
    <loader :loading="loading"></loader>
    <div class="container">
      <div class="quoteleft">
        <div class="title">Checkout</div>
        <br />
        <status-component />
        <div class="subtitle">Your Information</div>
        <br /><br />
        <div class="fieldleft">
          <label
            class="tinylabel"
            :class="{ validationlabel: hasErrors('firstName') }"
            >First Name <red v-pre>*</red></label
          ><input
            v-model="quote.checkout.info.firstName"
            type="text"
            name="firstName"
            :class="{ validationfield: hasErrors('firstName') }"
            @input="validatedFieldChanged"
          />
          <validation-error name="firstName" :errors="validationErrors" />
        </div>
        <div class="fieldright">
          <label
            class="tinylabel"
            :class="{ validationlabel: hasErrors('lastName') }"
            >Last Name <red v-pre>*</red></label
          ><input
            v-model="quote.checkout.info.lastName"
            type="text"
            name="lastName"
            :class="{ validationfield: hasErrors('lastName') }"
            @input="validatedFieldChanged"
          />
          <validation-error name="lastName" :errors="validationErrors" />
        </div>
        <div class="fieldleft">
          <label
            class="tinylabel"
            :class="{ validationlabel: hasErrors('phone') }"
            >Phone Number <red v-pre>*</red></label
          ><input
            v-model="quote.checkout.info.phone"
            v-maska="['(###) ###-####', '(###) ###-####']"
            type="tel"
            name="phone"
            :class="{ validationfield: hasErrors('phone') }"
            @maska="phoneRaw = $event.target.dataset.maskRawValue"
            @input="validatedFieldChanged"
          />
          <validation-error name="phone" :errors="validationErrors" />
        </div>
        <div class="fieldright">
          <label
            class="tinylabel"
            :class="{ validationlabel: hasErrors('dob') }"
            >Date of Birth <red v-pre>*</red></label
          ><input
            v-model="quote.checkout.info.dob"
            type="date"
            style="padding: 0px"
            :max="minus18YearsDate"
            name="dob"
            :class="{ validationfield: hasErrors('dob') }"
            @change="validatedFieldChanged"
          />
          <validation-error name="dob" :errors="validationErrors" />
        </div>
        <div style="clear: both"></div>
        <div class="field">
          <label
            class="tinylabel"
            :class="{ validationlabel: hasErrors('email') }"
            >Email <red v-pre>*</red></label
          ><input
            v-model="quote.checkout.info.email"
            type="text"
            name="email"
            :class="{ validationfield: hasErrors('email') }"
            @input="validatedFieldChanged"
          />
          <validation-error name="email" :errors="validationErrors" />
        </div>
        <br />
        <br />
        <p>
          <input
            id="emaildocs"
            v-model="quote.checkout.receiveByEmailConsent"
            type="checkbox"
            class="styledchecked"
          />
          <label for="emaildocs">
            I'd like to receieve my Renters Insurance policy and billing
            documents by email.
          </label>
        </p>
        <br />
        <p>
          By clicking "Review Details" below, I acknowledge that I have read,
          agreed, and understand this disclosure:
          <a class="javascriptlink" @click="showConsentModal()">
            Electronic Business Consent.
          </a>
        </p>
        <div class="spacer"></div>
        <hr />
        <div class="spacer"></div>
        <!--------------------------------------------------->
        <div class="subtitle">Additional Parties - No Additional Cost</div>
        <p style="font-size: 13px; line-height: 22px">
          Only applicable for Renters Insurance policy.
        </p>
        <br /><br />
        <table
          width="100%"
          border="0"
          cellspacing="0"
          cellpadding="0"
          class="additional-table"
        >
          <tbody>
            <tr>
              <td valign="top" width="75%">
                <span
                  id="roommate"
                  onclick="document.getElementById('roommate-content').classList.toggle('show');document.getElementById('roommate').classList.toggle('checked');"
                  >Roommate
                </span>
                <div
                  id="roommate-content"
                  class="additional-content"
                  style="display: none"
                >
                  You can add one roommate to your policy. (Your spouse,
                  domestic partner or dependent are automatically covered and
                  don't need to be added).<br /><br />
                  Have more than one roommate? No worries, just have them
                  purchase another policy from us.
                </div>
                <div
                  v-for="roommate in quote.checkout.roommates"
                  :key="'roommate' + quote.checkout.roommates.indexOf(roommate)"
                  class="Additional-content-enty"
                  @click="removeRoommate(roommate)"
                >
                  {{ roommate.firstName }} {{ roommate.lastName }}
                </div>
              </td>
              <td width="100" style="text-align: right">
                <input
                  id="add-roommate-2"
                  v-model="hasRoomate"
                  class="additional-add"
                  :disabled="hasRoomate"
                  type="checkbox"
                  @change="showAddRoomateModal()"
                />
                <label for="add-roommate-2"></label>
              </td>
            </tr>
            <tr>
              <td valign="top" width="75%">
                <span
                  id="roommate"
                  onclick="document.getElementById('interestedparty-content').classList.toggle('show');document.getElementById('interestedparty').classList.toggle('checked');"
                  >Interested Party</span
                >
                <div
                  id="interestedparty-content"
                  class="additional-content"
                  style="display: none"
                >
                  This is typically your landlord or property manager. Put down
                  their information and we'll automatically notify them that
                  you've got coverage.
                </div>
                <div
                  v-if="hasInterestedParty"
                  class="Additional-content-enty"
                  @click="removeInterestedParty(quote.checkout.interestedParty)"
                >
                  {{ quote.checkout.interestedParty.firstName }}
                  {{ quote.checkout.interestedParty.lastName }}
                </div>
              </td>
              <td width="100" style="text-align: right">
                <input
                  id="3"
                  v-model="hasInterestedParty"
                  class="additional-add"
                  :disabled="hasInterestedParty"
                  type="checkbox"
                  @change="showInterestedPartyModal()"
                />
                <label for="3"></label>
              </td>
            </tr>
          </tbody>
        </table>
        <div style="clear: both"></div>
        <!----------------->
        <div class="spacer"></div>
        <hr />
        <div class="spacer"></div>
        <!--------------------------------------------------->
        <div class="subtitle">Property Address</div>
        <br /><br />
        <div style="clear: both"></div>
        <p style="font-size: 20px">{{ quote.address.formatted }}</p>
        <br />
        <p><strong>Mailing Address</strong></p>
        <p>
          <input
            id="usesameadddress"
            v-model="quote.checkout.useSameAddressForMailing"
            type="checkbox"
            class="styledchecked"
            :true-value="true"
          />
          <label for="usesameadddress"> Use same address as above </label>
        </p>
        <br />
        <div v-if="!quote.checkout.useSameAddressForMailing">
          <div class="fieldleft">
            <label
              class="tinylabel"
              :class="{ validationlabel: hasErrors('mailingAddress') }"
              >Street Address <red v-pre>*</red></label
            ><input
              v-model="quote.checkout.mailingAddress.address"
              type="text"
              name="mailingAddress"
              :class="{ validationfield: hasErrors('mailingAddress') }"
              @change="validatedFieldChanged"
            />
            <validation-error name="mailingAddress" :errors="validationErrors" />
          </div>
          <div class="fieldright">
            <label class="tinylabel">Apt/Suite</label
            ><input v-model="quote.checkout.mailingAddress.apt" type="text" />
          </div>
          <div class="fieldleft">
            <label
              class="tinylabel"
              :class="{ validationlabel: hasErrors('mailingCity') }"
              >City <red v-pre>*</red></label
            ><input
              v-model="quote.checkout.mailingAddress.city"
              type="text"
              name="mailingCity"
              :class="{ validationfield: hasErrors('mailingCity') }"
              @input="validatedFieldChanged"
            />
            <validation-error name="mailingCity" :errors="validationErrors" />
          </div>
          <div class="fieldright">
            <label
              class="tinylabel"
              :class="{ validationlabel: hasErrors('mailingState') }"
              >State <red v-pre>*</red></label
            >
            <us-states-box
              key="mailing-state-box"
              v-model="quote.checkout.mailingAddress.state"
              :initial="quote.checkout.mailingAddress.state"
              :select-style="{ validationfield: hasErrors('mailingState') }"
              name="mailingState"
              @change="validatedFieldChanged"
            ></us-states-box>
            <validation-error name="mailingState" :errors="validationErrors" />
          </div>
          <div class="fieldleft">
            <label
              class="tinylabel"
              :class="{ validationlabel: hasErrors('mailingZip') }"
              >Zip <red v-pre>*</red></label
            ><input
              v-model="quote.checkout.mailingAddress.zip"
              type="text"
              name="mailingZip"
              :class="{ validationfield: hasErrors('mailingZip') }"
              @input="validatedFieldChanged"
            />
            <validation-error name="mailingZip" :errors="validationErrors" />
          </div>
        </div>
        <div class="spacer"></div>
        <hr />
        <div id="payment" class="spacer"></div>
        <!--------------------------------------------------->
        <template v-if="quote.hasPersonalInsurance">
          <div class="subtitle">School Information</div>
          <br /><br />
          <div class="fieldleft">
            <label
              class="tinylabel"
              :class="{ validationlabel: hasErrors('schoolCity') }"
              >School City <red v-pre>*</red></label
            >
            <select
              v-model="quote.checkout.schoolCity"
              name="schoolCity"
              :class="{ validationfield: hasErrors('schoolCity') }"
              @change="readNssiSchools"
            >
              <option value="" selected>Please Select...</option>
              <option v-for="city in nssiSchoolCities" :key="city.id">
                {{ city.mcity }}
              </option>
            </select>
            <validation-error name="schoolCity" :errors="validationErrors" />
          </div>
          <div class="fieldleft">
            <label
              class="tinylabel"
              :class="{ validationlabel: hasErrors('schoolName') }"
              >School Name <red v-pre>*</red></label
            >
            <select
              v-model="quote.checkout.schoolKey"
              name="schoolName"
              :class="{ validationfield: hasErrors('schoolName') }"
              :disabled="schoolDisabled"
              @change="validatedFieldChanged"
            >
              <option value="" selected>Please Select...</option>
              <option
                v-for="school in nssiSchoolsByCity"
                :key="school.id"
                :value="school.id"
              >
                {{ school.sch_name }}
              </option>
            </select>
            <validation-error name="schoolName" :errors="validationErrors" />
          </div>
          <div class="spacer"></div>
          <hr />
          <div class="spacer"></div>
        </template>
        <!--------------------------------------------------->
        <div ref="payment" class="subtitle">Payment Method</div>
        <p>
          Your one-time payment will be processed today, even if your policy is
          effective later. We'll then automatically charge your recurring
          payments.
        </p>
        <input
          id="creditcard"
          v-model="quote.checkout.paymentMethod.creditCard"
          type="radio"
          class="styledradio"
          name="paymentmethod"
          :value="true"
          @change="quote.checkout.paymentMethod.creditCard = true"
        />
        <label for="creditcard" style="font-size: 16px"> 
          Credit / Debit Card
        </label>
        <br /><br />
        <!---------- credit card fields -------->
        <div v-if="quote.checkout.paymentMethod.creditCard">
          <div class="field">
            <label
              class="tinylabel"
              :class="{ validationlabel: hasErrors('nameOnCard') }"
              >Name on Card <red v-pre>*</red></label
            ><input
              v-model="quote.checkout.paymentMethod.nameOnCard"
              type="text"
              name="nameOnCard"
              :class="{ validationfield: hasErrors('nameOnCard') }"
              @input="validatedFieldChanged"
            />
            <validation-error name="nameOnCard" :errors="validationErrors" />
          </div>
          <br />
          <div class="fieldleft">
            <label
              class="tinylabel"
              :class="{ validationlabel: hasErrors('cardNumber') }"
              >Card Number <red v-pre>*</red></label
            >
            <input
              v-model="quote.checkout.paymentMethod.cardNumber"
              v-maska="{ mask: '################' }"
              type="text"
              name="cardNumber"
              :class="{ validationfield: hasErrors('cardNumber') }"
              @input="validatedFieldChanged"
            />
            <validation-error name="cardNumber" :errors="validationErrors" />
          </div>
          <div class="fieldright">
            <img
              :src="require('@/assets/images/creditcards-logo.png')"
              width="253"
              height="48"
              alt="Credit Cards Payment Method"
            />
          </div>
          <div style="clear: both"></div>
          <div class="fieldleft">
            <label
              class="tinylabel"
              :class="{ validationlabel: hasErrors('cvv') }"
              >CVC <red v-pre>*</red></label
            ><input
              v-model="quote.checkout.paymentMethod.cvv"
              v-maska="{ mask: '####' }"
              type="text"
              name="cvv"
              :class="{ validationfield: hasErrors('cvv') }"
              @input="validatedFieldChanged"
            />
            <hint v-pre style="font-size: 12px">
              This is the 3 or 4 digit number on the back of the card.
            </hint>
            <validation-error name="cvv" :errors="validationErrors" />
          </div>
          <div class="fieldright">
            <label
              class="tinylabel"
              :class="{ validationlabel: hasErrors('expDateMonth') }"
              >Expiration Date <red v-pre>*</red></label
            >
            <div style="width: 40%; float: left; margin-right: 1%">
              <select
                v-model="quote.checkout.paymentMethod.expDateMonth"
                class="plainfieldselect"
                placeholder="Select Month"
                name="expDateMonth"
                :class="{ validationfield: hasErrors('expDateMonth') }"
                @change="validatedFieldChanged"
              >
                <option v-for="month in cardMonths" :key="month" :value="month">
                  {{ month }}
                </option>
              </select>
              <validation-error name="expDateMonth" :errors="validationErrors" />
            </div>
            <div style="width: 50%; float: left">
              <select
                v-model="quote.checkout.paymentMethod.expDateYear"
                class="plainfieldselect"
                placeholder="Select Year"
                name="expDateYear"
                :class="{ validationfield: hasErrors('expDateYear') }"
                @change="validatedFieldChanged"
              >
                <option v-for="year in cardYears" :key="year" :value="year">
                  {{ year }}
                </option>
              </select>
              <validation-error name="expDateYear" :errors="validationErrors" />
            </div>
          </div>
        </div>
        <div style="clear: both"></div>
        <!---------- next payment notice --------><br /><br />
        <p class="paymentplannotice">
          <strong v-if="rentersNextPayment">{{ rentersNextPayment }}</strong>
          <br />
          <br />
          <strong v-if="nssiNextPayment">{{ nssiNextPayment }}</strong>
          <br />
        </p>
        <br /><br />
        <p><strong>Billing Address</strong></p>
        <div class="billingaddress-radios">
          <input
            id="billingaddress-property"
            v-model="quote.checkout.paymentMethod.billingAddressType"
            type="radio"
            class="styledradio"
            name="billingaddress"
            checked=""
            :value="1"
          />
          <label for="billingaddress-property"
            >Use Property Address:<br />
            <hint> {{ quote.address.formatted }}</hint>
          </label>
          <input
            id="billingaddress-mailing"
            v-model="quote.checkout.paymentMethod.billingAddressType"
            type="radio"
            class="styledradio"
            name="billingaddress"
            :value="2"
          />
          <label for="billingaddress-mailing"
            >Use Mailing Address:<br />
            <hint>{{ mailingAddress }}</hint>
          </label>
          <input
            id="billingaddress-different"
            v-model="quote.checkout.paymentMethod.billingAddressType"
            type="radio"
            class="styledradio"
            name="billingaddress"
            :value="3"
          />
          <label for="billingaddress-different"
            >Use different billing address</label
          >
        </div>
        <div style="clear: both"></div>
        <div v-if="quote.checkout.paymentMethod.billingAddressType == 3">
          <br />
          <div class="fieldleft">
            <label
              class="tinylabel"
              :class="{ validationlabel: hasErrors('billingFirstName') }"
              >First Name <red v-pre>*</red></label
            ><input
              v-model="quote.checkout.paymentMethod.billingAddress.firstName"
              type="text"
              name="billingFirstName"
              :class="{ validationfield: hasErrors('billingFirstName') }"
              @input="validatedFieldChanged"
            />
            <validation-error name="billingFirstName" :errors="validationErrors" />
          </div>
          <div class="fieldright">
            <label
              class="tinylabel"
              :class="{ validationlabel: hasErrors('billingLastName') }"
              >Last Name <red v-pre>*</red></label
            ><input
              v-model="quote.checkout.paymentMethod.billingAddress.lastName"
              type="text"
              name="billingLastName"
              :class="{ validationfield: hasErrors('billingLastName') }"
              @input="validatedFieldChanged"
            />
            <validation-error name="billingLastName" :errors="validationErrors" />
          </div>
          <div class="fieldleft">
            <label
              class="tinylabel"
              :class="{ validationlabel: hasErrors('billingAddress') }"
              >Street Address <red v-pre>*</red></label
            ><input
              v-model="quote.checkout.paymentMethod.billingAddress.address"
              type="text"
              name="billingAddress"
              :class="{ validationfield: hasErrors('billingAddress') }"
              @input="validatedFieldChanged"
            />
            <validation-error name="billingAddress" :errors="validationErrors" />
          </div>
          <div class="fieldright">
            <label class="tinylabel">Apt/Suite</label
            ><input
              v-model="quote.checkout.paymentMethod.billingAddress.apt"
              type="text"
            />
          </div>
          <div class="fieldleft">
            <label
              class="tinylabel"
              :class="{ validationlabel: hasErrors('billingCity') }"
              >City <red v-pre>*</red></label
            ><input
              v-model="quote.checkout.paymentMethod.billingAddress.city"
              type="text"
              name="billingCity"
              :class="{ validationfield: hasErrors('billingCity') }"
              @input="validatedFieldChanged"
            />
            <validation-error name="billingCity" :errors="validationErrors" />
          </div>
          <div class="fieldright">
            <label
              class="tinylabel"
              :class="{ validationlabel: hasErrors('billingState') }"
              >State <red v-pre>*</red></label
            >
            <us-states-box
              v-model="quote.checkout.paymentMethod.billingAddress.state"
              :initial="quote.checkout.paymentMethod.billingAddress.state"
              name="billingState"
              :select-style="{ validationfield: hasErrors('billingState') }"
              @change="validatedFieldChanged"
            />
            <validation-error name="billingState" :errors="validationErrors" />
          </div>
          <div class="fieldleft">
            <label
              class="tinylabel"
              :class="{ validationlabel: hasErrors('billingZip') }"
              >Zip <red v-pre>*</red></label
            ><input
              v-model="quote.checkout.paymentMethod.billingAddress.zip"
              type="text"
              name="billingZip"
              :class="{ validationfield: hasErrors('billingZip') }"
              @input="validatedFieldChanged"
            />
            <validation-error name="billingZip" :errors="validationErrors" />
          </div>
        </div>
        <div class="spacer"></div>
        <hr />
        <div class="spacer"></div>
        <!--------------------------------------------------->
        <div style="text-align: center">
          <button
            :class="{ disabled: !validated }"
            @click="goToPage('quote-review')"
          >
            Review Details
          </button>
        </div>
        <br /><br /><br /><br /><br /><br />
      </div>
      <!--------------------------------------------------------------------------------------------->
      <quote-cart />
    </div>
    <base-modal name="electronicConsentModal">
      <electronic-consent-modal />
    </base-modal>
    <base-modal name="messageServiceModal">
      <message-service-modal />
    </base-modal>
    <add-user-modal name="addUserModal" />
    <add-interested-party-modal name="addInterestedParty" />
  </section>
</template>

<script lang="ts" setup>
import ElectronicConsentModal from "@/views/modals/context/ElectronicConsentModal.vue";
import MessageServiceModal from "@/views/modals/context/MessageServiceModal.vue";
import AddUserModal from "@/views/modals/context/AddUserModal.vue";
import AddInterestedPartyModal from "@/views/modals/context/AddInterestedPartyModal.vue";
import QuoteCart from "@/views/quote/QuoteCart.vue";
import UsStatesBox from "@/components/UsStatesBox.vue";
import { InsuranceUser } from "@/models/InsuranceUser";
import { InterestedParty } from "@/models/InterestedParty";
import { NssiData } from "@/api/NssiData";
import Loader from "@/components/MainLoader.vue";
import { BillingAddressType } from "@/models/PaymentMethod";
import {
  formatDateForDateInput,
  formatAddress,
  formatAmount,
  calculateQuoteNssi,
  scrollTop,
  scrollMeTo,
  minus18YearsDate,
  stat,
} from "@/utils/Utils";
import StatusComponent from "@/components/StatusComponent.vue";
import { PaymentOptions } from "@/models/QuoteInsurance";
import { DateTimeFormatter, LocalDate } from "@js-joda/core";
import ValidationError from "@/components/ValidationError.vue";
import { validateCard, validateCVV } from "@/utils/CreditCards";
import { onMounted, ref, computed, Ref, ComputedRef, watch } from "vue";
import { useQuoteStore } from "@/stores/root/quote";
import { useUserStore } from "@/stores/root/users";
import { useStatusStore } from "@/stores/root/status";
import useModal from "@/hooks/useModal";
import Modals from "@/utils/Modals";
import BaseModal from "@/views/modals/BaseModal.vue";
import { UserData } from "@/api/UserData";

const props = defineProps({
  anchor: {
    type: String,
    default: "",
  },
});

const title = "Checkout";
const loading: Ref<boolean> = ref(false);
//const intrestedShow: Ref<boolean> = ref(true);
const nssiSchoolCities: Ref<any[]> = ref([]);
const nssiSchoolsByCity: Ref<any[]> = ref([]);
const phoneRaw = ref("");
const hasRoomate = ref(false);
const hasInterestedParty = ref(false);
const validationErrors: Ref<any[]> = ref([]);
const statusStore = useStatusStore();
const electronicConsentModal = ref();
const messageServiceModal = ref();
const quote = useQuoteStore();
const userStore = useUserStore();
const user = userStore.user;
const { toggleModal } = useModal();
const schoolDisabled = ref();

const readNssiSchoolsCities = async () => {
  nssiSchoolCities.value = [];
  nssiSchoolsByCity.value = [];
  console.log("Get Cities");
  const citiesResult = await NssiData.getCities(quote);
  console.log("Cities Result", citiesResult);
  if (citiesResult.error) {
    stat(statusStore).error(citiesResult.message);
    scrollMeTo("status");
  } else {
    nssiSchoolCities.value = [];
    nssiSchoolsByCity.value = [];
    //TODO refactor for loop why?
    nssiSchoolCities.value = citiesResult.result.cities;
    // citiesResult.result.ObjectList.forEach((element: any) => {
    //   const city = {
    //     key: element.Key,
    //     value: element.Value,
    //   };
    //   nssiSchoolCities.value.push(city);
    // });
    console.log("cities", nssiSchoolCities.value);
  }
};

function clearValidationMessage(name: string): void {
  const elements = validationErrors.value.filter((element) => {
    return element.name == name;
  });
  elements.forEach((element) => {
    const index = validationErrors.value.indexOf(element);
    validationErrors.value.splice(index, 1);
  });
  if (!validationErrors.value.length) {
    stat(statusStore).clear();
  }
}

function validatedFieldChanged(event: any): void {
  clearValidationMessage(event.target.name);
}

const readNssiSchools = async (event: any = null) => {
  if (event) {
    validatedFieldChanged(event);
  }
  loading.value = true;
  nssiSchoolsByCity.value = [];

  const result = await NssiData.getSchoolsByCity(quote);
  console.log("Schools", result);
  if (result.error) {
    stat(statusStore).error(result.message);
    scrollMeTo("status");
  } else {
    nssiSchoolsByCity.value = [];
    //TODO refactor for loop why?
    nssiSchoolsByCity.value = result.result.schools;
    // result.result.ObjectList.forEach((element: any) => {
    //   const school = {
    //     key: element.Key,
    //     value: element.Value,
    //   };
    //   nssiSchoolsByCity.value.push(school);
    // });
  }
  loading.value = false;
  // if (event) {
  //   validatedFieldChanged(event);
  // }
};
// watch(
//   function () {
//     return quote.checkout.schoolKey;
//   },
//   function (newValue, oldValue) {
//     quote.checkout.schoolName = nssiSchoolsByCity.value.find(
//       (school) => school.id == newValue
//     )?.sch_name;
//   }
// );
//TODO user why
watch([quote, user], (current) => {
  if (current[0].checkout.interestedParty.firstName.length > 0) {
    hasInterestedParty.value = true;
  }
  if (current[0].checkout.roommates.length > 0) {
    hasRoomate.value = true;
  }
  if (!current[1].loggedIn) {
    quote.setQuoteStep("quote-account");
  }
  current[0].checkout.schoolCity.length
    ? (schoolDisabled.value = false)
    : (schoolDisabled.value = true);
});

watch(nssiSchoolsByCity, (current) => {
  quote.checkout.schoolCity.length > 0 && current.length > 0
    ? (schoolDisabled.value = false)
    : (schoolDisabled.value = true);
});

onMounted(async () => {
  if (!user.loggedIn) {
    quote.setQuoteStep("quote-account");
  }
  quote.checkout.schoolCity.length > 0 && nssiSchoolsByCity.value.length > 0
    ? (schoolDisabled.value = false)
    : (schoolDisabled.value = true);
  if (props.anchor) {
    scrollMeTo(props.anchor);
  }
  loading.value = true;
  if (
    user &&
    user.loggedIn &&
    user.firstName &&
    !quote.checkout.info.firstName
  ) {
    quote.checkout.info.firstName = user.firstName;
  }
  if (user && user.loggedIn && user.lastName && !quote.checkout.info.lastName) {
    quote.checkout.info.lastName = user.lastName;
  }
  if (quote.hasPersonalInsurance) {
    await readNssiSchoolsCities();
  }
  if (quote.checkout.schoolCity) {
    await readNssiSchools();
  }
  hasRoomate.value = quote.checkout.roommates.length > 0;
  hasInterestedParty.value = quote.checkout.interestedParty.firstName != "";
  loading.value = false;
});

function createValidationMessages(): void {
  validationErrors.value.length = 0;
  if (!quote.checkout.info.firstName) {
    const error = {
      name: "firstName",
      value: "First name is required.",
    };
    validationErrors.value.push(error);
  }
  if (!quote.checkout.info.lastName) {
    const error = {
      name: "lastName",
      value: "Last name is required.",
    };
    validationErrors.value.push(error);
  }
  if (!quote.checkout.info.phone) {
    const error = {
      name: "phone",
      value: "Phone number is required.",
    };
    validationErrors.value.push(error);
  }
  if (!quote.checkout.info.dob) {
    const error = {
      name: "dob",
      value: "Date of birth is required.",
    };
    validationErrors.value.push(error);
  } else {
    if (
      +new Date(quote.checkout.info.dob).setHours(0, 0, 0, 0) >
      +new Date(minus18YearsDate.value).setHours(0, 0, 0, 0)
    ) {
      const error = {
        name: "dob",
        value: "Must be 18 years or older.",
      };
      validationErrors.value.push(error);
    }
  }
  if (!quote.checkout.info.email) {
    const error = {
      name: "email",
      value: "Email is required.",
    };
    validationErrors.value.push(error);
  }

  if (!quote.checkout.useSameAddressForMailing) {
    if (!quote.checkout.mailingAddress.address) {
      const error = {
        name: "mailingAddress",
        value: "Address is required.",
      };
      validationErrors.value.push(error);
    }
    if (!quote.checkout.mailingAddress.city) {
      const error = {
        name: "mailingCity",
        value: "City is required.",
      };
      validationErrors.value.push(error);
    }
    if (!quote.checkout.mailingAddress.state.short) {
      const error = {
        name: "mailingState",
        value: "State is required.",
      };
      validationErrors.value.push(error);
    }
    if (!quote.checkout.mailingAddress.zip) {
      const error = {
        name: "mailingZip",
        value: "Zip code is required.",
      };
      validationErrors.value.push(error);
    }
  } // useSameAddressForMailing
  if (quote.hasPersonalInsurance) {
    if (!quote.checkout.schoolCity) {
      const error = {
        name: "schoolCity",
        value: "School city is required.",
      };
      validationErrors.value.push(error);
    }
    if (!quote.checkout.schoolKey) {
      const error = {
        name: "schoolName",
        value: "School name is required.",
      };
      validationErrors.value.push(error);
    }
  } // hasPersonalInsurance
  if (quote.checkout.paymentMethod.creditCard) {
    let creditCardValidated = false;
    if (!quote.checkout.paymentMethod.nameOnCard) {
      const error = {
        name: "nameOnCard",
        value: "Name on card is required.",
      };
      validationErrors.value.push(error);
    }
    if (!quote.checkout.paymentMethod.cardNumber) {
      const error = {
        name: "cardNumber",
        value: "Card number is required.",
      };
      validationErrors.value.push(error);
    } else {
      creditCardValidated = validateCard(
        quote.checkout.paymentMethod.cardNumber
      );
      if (!creditCardValidated) {
        const error = {
          name: "cardNumber",
          value:
            "Entered card is not supported. We support Master card, Visa, American Express and Discover.",
        };
        validationErrors.value.push(error);
      }
    }
    if (!quote.checkout.paymentMethod.cvv) {
      const error = {
        name: "cvv",
        value: "CVC is required.",
      };
      validationErrors.value.push(error);
    } else if (creditCardValidated) {
      if (
        !validateCVV(
          quote.checkout.paymentMethod.cardNumber,
          quote.checkout.paymentMethod.cvv
        )
      ) {
        const error = {
          name: "cvv",
          value: "Invalid CVC number.",
        };
        validationErrors.value.push(error);
      }
    }
    if (!quote.checkout.paymentMethod.expDateMonth) {
      const error = {
        name: "expDateMonth",
        value: "Month is required.",
      };
      validationErrors.value.push(error);
    }
    if (!quote.checkout.paymentMethod.expDateYear) {
      const error = {
        name: "expDateYear",
        value: "Year is required.",
      };
      validationErrors.value.push(error);
    }
  } // credit card
  if (
    quote.checkout.paymentMethod.billingAddressType ==
    BillingAddressType.Different
  ) {
    if (!quote.checkout.paymentMethod.billingAddress.firstName) {
      const error = {
        name: "billingFirstName",
        value: "First name is required.",
      };
      validationErrors.value.push(error);
    }
    if (!quote.checkout.paymentMethod.billingAddress.lastName) {
      const error = {
        name: "billingLastName",
        value: "Last name is required.",
      };
      validationErrors.value.push(error);
    }
    if (!quote.checkout.paymentMethod.billingAddress.address) {
      const error = {
        name: "billingAddress",
        value: "Address is required.",
      };
      validationErrors.value.push(error);
    }
    if (!quote.checkout.paymentMethod.billingAddress.city) {
      const error = {
        name: "billingCity",
        value: "City is required.",
      };
      validationErrors.value.push(error);
    }
    if (!quote.checkout.paymentMethod.billingAddress.state.short) {
      const error = {
        name: "billingState",
        value: "State is required.",
      };
      validationErrors.value.push(error);
    }
    if (!quote.checkout.paymentMethod.billingAddress.zip) {
      const error = {
        name: "billingZip",
        value: "Zip code is required.",
      };
      validationErrors.value.push(error);
    }
  } //billingAddress
} // createValidationMessages

const validated = computed(() => {
  let result = true;
  const infoValidated =
    quote.checkout.info.firstName &&
    quote.checkout.info.lastName &&
    quote.checkout.info.phone &&
    quote.checkout.info.dob &&
    quote.checkout.info.email;
  result = result && Boolean(infoValidated);
  if (result) {
    if (
      +new Date(quote.checkout.info.dob).setHours(0, 0, 0, 0) >
      +new Date(minus18YearsDate.value).setHours(0, 0, 0, 0)
    ) {
      result = false;
    }
  }
  if (!result) {
    return false;
  }
  if (!quote.checkout.useSameAddressForMailing) {
    const mailAddressValidated =
      quote.checkout.mailingAddress.address &&
      quote.checkout.mailingAddress.city &&
      quote.checkout.mailingAddress.state.short &&
      quote.checkout.mailingAddress.zip;
    result = result && Boolean(mailAddressValidated);
  }
  if (!result) {
    return false;
  }
  if (quote.hasPersonalInsurance) {
    result =
      result &&
      Boolean(quote.checkout.schoolCity) &&
      Boolean(quote.checkout.schoolKey);
  }
  if (!result) {
    return false;
  }
  if (quote.checkout.paymentMethod.creditCard) {
    const crediCardValidated =
      Boolean(quote.checkout.paymentMethod.nameOnCard) &&
      Boolean(quote.checkout.paymentMethod.cardNumber) &&
      Boolean(quote.checkout.paymentMethod.cvv) &&
      Boolean(quote.checkout.paymentMethod.expDateMonth) &&
      Boolean(quote.checkout.paymentMethod.expDateYear);
    result = result && crediCardValidated;
    if (result) {
      const creditCardValidated = validateCard(
        quote.checkout.paymentMethod.cardNumber
      );
      if (!creditCardValidated) {
        return false;
      }
      result =
        result &&
        validateCVV(
          quote.checkout.paymentMethod.cardNumber,
          quote.checkout.paymentMethod.cvv
        );
    }
  }
  if (!result) {
    return false;
  }
  if (
    quote.checkout.paymentMethod.billingAddressType ==
    BillingAddressType.Different
  ) {
    const billAddressValidated =
      quote.checkout.paymentMethod.billingAddress.firstName &&
      quote.checkout.paymentMethod.billingAddress.lastName &&
      quote.checkout.paymentMethod.billingAddress.address &&
      quote.checkout.paymentMethod.billingAddress.city &&
      quote.checkout.paymentMethod.billingAddress.state.short &&
      quote.checkout.paymentMethod.billingAddress.zip;
    result = result && Boolean(billAddressValidated);
  }
  return result;
});

function goToPage(command: string) {
  if (!validated.value) {
    createValidationMessages();
    stat(statusStore).error("Please fill in required fields.");
    scrollTop();
    return;
  }
  quote.checkout.info.phone = phoneRaw.value;
  const schoolKey = quote.checkout.schoolKey;
  const selectedSchool = nssiSchoolsByCity.value.filter((school) => {
    console.log("SCHOOL", school);
    if (school.id == schoolKey) return school.sch_name;
  });
  if (schoolKey) {
    quote.checkout.schoolName = selectedSchool[0].sch_name;
  }
  quote.setQuoteStep(command);
}

function hasErrors(name: string): boolean {
  return (
    validationErrors.value.find((element) => {
      return element.name == name;
    }) != null
  );
}

function showConsentModal() {
  toggleModal(Modals.ELECTRONIC_CONSENT_MODAL.label);
}

/**
 * Shows modal to add new user
 */
function showAddRoomateModal() {
  hasRoomate.value = false;
  toggleModal(Modals.ADD_USER_MODAL.label);
}

/**
 * Shows modal to add new party user
 */
function showInterestedPartyModal() {
  hasInterestedParty.value = false;
  toggleModal(Modals.ADD_INTERESTED_PARTY.label);
}

/**
 * User (roommate or authorized) has been added from the modal
 */
function onUserAdded() {
  hasRoomate.value = true;
}

/**
 * Remove roommate from list of quote roommates
 */
function removeRoommate(roommate: InsuranceUser) {
  const index = quote.checkout.roommates.indexOf(roommate);
  if (index > -1) {
    quote.checkout.roommates.splice(index, 1);
  }
  hasRoomate.value = quote.checkout.roommates.length > 0;
}
/**
 * Interested party has been added from the modal
 */
function onInterestedPartyAdded() {
  hasInterestedParty.value = true;
}
/**
 * Removes interested party from list of quote interested parties
 */
function removeInterestedParty(party: InterestedParty) {
  quote.checkout.interestedParty = new InterestedParty();
  hasInterestedParty.value = false;
}

const cardYears: ComputedRef<string[]> = computed(() => {
  const result = [];
  const currentYear = new Date().getFullYear();
  for (let i = currentYear; i < currentYear + 20; i++) {
    result.push(i.toString());
  }
  return result;
});

function pad(num: number, size: number) {
  let res = num.toString();
  while (res.length < size) res = "0" + num;
  return res;
}

const cardMonths: ComputedRef<string[]> = computed(() => {
  const result = [];
  for (let i = 1; i <= 12; i++) {
    result.push(pad(i, 2));
  }
  return result;
});

const mailingAddress: ComputedRef<string> = computed(() => {
  if (quote.checkout.useSameAddressForMailing) {
    return quote.address.formatted;
  } else {
    return formatAddress(quote.checkout.mailingAddress);
  }
});

const rentersNextPayment: ComputedRef<string> = computed(() => {
  let date = undefined;
  if (quote.rentersInsurance.paymentOption == PaymentOptions.Annual) {
    return "";
  } else if (quote.rentersInsurance.paymentOption == PaymentOptions.FourPay) {
    date = LocalDate.now().plusMonths(4);
  } else if (quote.rentersInsurance.paymentOption == PaymentOptions.Monthly) {
    date = LocalDate.now().plusMonths(1);
  }
  const amtFormatted = formatAmount(
    quote.rentersInsurance.installmentAmount + quote.rentersInsurance.serviceFee
  );
  const dateFormatted = date?.format(DateTimeFormatter.ofPattern("M/d/yyyy"));
  return `Your next payment for your Renters Insurance (${amtFormatted}) will be automatically charged on ${dateFormatted}.`;
});

const nssiNextPayment: ComputedRef<string> = computed(() => {
  if (!quote.hasPersonalInsurance) {
    return "";
  }
  if (quote.personalInsurance.paymentOption == PaymentOptions.Annual) {
    return "";
  } else if (quote.personalInsurance.paymentOption == PaymentOptions.Monthly) {
    const date = LocalDate.now().plusMonths(1);
    const amtFormatted = formatAmount(calculateQuoteNssi(quote));
    const dateFormatted = date?.format(DateTimeFormatter.ofPattern("M/d/yyyy"));
    return `Your next payment for your Accidental Damage Personal Property Insurance (${amtFormatted}) will be automatically charged on ${dateFormatted}.`;
  }
  return "";
});
</script>
